/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ICipBackTopFooterData } from './cip-back-top-footer.data';
import { ICipBackTopFooterProps } from './cip-back-top-footer.props.autogenerated';

export interface ICipBackTopFooterViewProps extends ICipBackTopFooterProps<ICipBackTopFooterData> {}

/**
 *
 * CipBackTopFooter component
 * @extends {React.PureComponent<ICipBackTopFooterProps<ICipBackTopFooterData>>}
 */
class CipBackTopFooter extends React.PureComponent<ICipBackTopFooterProps<ICipBackTopFooterData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default CipBackTopFooter;
